import React from 'react';
import Badge from '@components/common/Badge';
import { QUERY_TYPE_LABELS } from '@app-types';
import type { QueryType } from '@app-types';

interface QueryTypeBadgeProps {
  type: QueryType;
  dataTestId?: string;
}

/**
 * Global/Personal badge for a query — blue ("info") for Global, neutral for
 * Personal. Single source for the variant + label mapping so it stays consistent
 * wherever a query's type is shown (list table, details header, …).
 */
const QueryTypeBadge: React.FC<QueryTypeBadgeProps> = ({ type, dataTestId }) => (
  <Badge variant={type === 'global' ? 'info' : 'default'} dataTestId={dataTestId}>
    {QUERY_TYPE_LABELS[type]}
  </Badge>
);

export default QueryTypeBadge;
